import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import ProfileFieldGrid from './ProfileFieldGrid'

const Job = props => {
  const { authenticationStore } = props
  const { currentUser } = authenticationStore
  const fields = [
    { title: 'Phòng ban', value: currentUser?.department?.name },
    { title: 'Công việc chính được giao', value: currentUser?.other?.main_work },
    { title: 'Chức danh', value: currentUser?.position?.name },
    { title: 'Bậc lương', value: currentUser?.other?.salary_scale },
    {
      title: 'Nghề nghiệp khi được tuyển dụng',
      value: currentUser?.other?.occupation,
    },
    { title: 'Hệ số', value: currentUser?.other?.coefficient },
    { title: 'Ngày tuyển dụng', value: currentUser?.other?.recruitment_day },
    { title: 'Ngày hưởng', value: currentUser?.other?.received_date },
    {
      title: 'Ngạch công chức',
      value: currentUser?.other?.civil_servant_rank,
    },
    {
      title: 'Phụ cấp chức vụ',
      value: currentUser?.other?.position_allowance,
    },
    { title: 'Mã ngạch', value: currentUser?.other?.quota_code },
    { title: 'Phụ cấp khác', value: currentUser?.other?.other_allowances },
  ]

  return <ProfileFieldGrid fields={fields} />
}

Job.propTypes = {
  authenticationStore: PropTypes.shape({
    currentUser: PropTypes.shape({
      department: PropTypes.shape({
        name: PropTypes.string,
      }),
      position: PropTypes.shape({
        name: PropTypes.string,
      }),
      other: PropTypes.shape({
        main_work: PropTypes.string,
        salary_scale: PropTypes.string,
        occupation: PropTypes.string,
        coefficient: PropTypes.string,
        recruitment_day: PropTypes.string,
        received_date: PropTypes.string,
        civil_servant_rank: PropTypes.string,
        position_allowance: PropTypes.string,
        quota_code: PropTypes.string,
        other_allowances: PropTypes.string,
      }),
    }),
  }),
}

export default inject('authenticationStore')(observer(Job))
